<template>
  <v-card height="auto">
    <vue-card-title
      title="View Documents"
      subtitle="Here you can see the detail view of documents"
      :icon="$getIcon('mdiEyeOutline')"
      closable
      dark
      @close="$emit('close')"
    ></vue-card-title>
    <v-card-text class="py-4 scrollbar-md">
      <div v-if="actionData.slug">
        <v-row>
          <v-col
            v-for="(item, index) in details || []"
            :key="index"
            md="4"
            cols="12"
          >
            <v-row no-gutters>
              <v-col cols="12">
                <v-icon v-text="$getIcon('mdiInformationOutline')"></v-icon>
                {{ item.name }}
              </v-col>
              <v-col cols="12" class="pl-7 black--text">
                <div v-if="item.name === 'Attachment'">
                  <a class="pointer" @click="downloadAttachment()">
                    {{ item.value }}
                    <v-icon
                      color="blue"
                      v-text="$getIcon('mdiDownload')"
                    ></v-icon>
                  </a>
                </div>
                <div v-else>{{ item.value || "N/A" }}</div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <vue-no-data v-else></vue-no-data>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-row no-gutters>
        <v-col class="text-right">
          <v-btn text @click="$emit('close')" class="text-capitalize">
            Cancel
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: {
    actionData: {
      type: [Object, Array],
      required: true
    }
  },
  data() {
    return {
      details: [],
      downloadUrl: ""
    };
  },
  created() {
    if (this.actionData && this.actionData.slug) {
      this.getData();
    }
  },
  methods: {
    getFileName(response) {
      if (response.attachment) {
        const attachmentUrl = response.attachment.substr(0);
        const fileName = attachmentUrl.split("/").pop();
        return fileName;
      } else return "";
    },
    getData() {
      this.loading = true;
      let endpoint = `/api/v1/org/${this.$store.state.shell.currentOrganizationId}/documents/${this.actionData.slug}/`;
      this.$axios
        .$get(endpoint)
        .then(response => {
          this.downloadUrl = response.attachment;
          this.details = [
            {
              name: "Title",
              value: response.title
            },
            {
              name: "Category",
              value: response.type || "N/A"
            },

            {
              name: "Is Archived",
              value: response.is_archived ? "True" : "False"
            },
            {
              name: "Attachment",
              value: this.getFileName(response)
            },
            {
              name: "Description",
              value: response.description
            }
          ];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    downloadAttachment() {
      window.open(this.downloadUrl);
    }
  }
};
</script>
